import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function ConciergeIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.04963 16C2.52021 11.2834 6.28298 7.52214 11 7.051V5.5H8V2.5H16V5.5H13V7.051C17.717 7.52214 21.4798 11.2834 21.9504 16H22V18H2V16H2.04963ZM12 9C16.072 9 19.444 12.06 19.938 16H4.062C4.556 12.06 7.928 9 12 9Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M22 19V21H2V19H22Z",
    fill: "currentColor"
  }));
}